// extracted by css-extract-rspack-plugin
export default {"root":"root-sxel1z","above":"above-jD1qt9","below":"below-sSoxEJ","empty":"empty-y9NCAw text-xs"};